export function isRangeString(value: unknown): boolean {
  return !!(typeof value === 'string' && value.match(/^[([].*?,.*?[)\]]$/));
}
